/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_SubtitleInputs */

const en_ui_thresholds_subtitle = /** @type {(inputs: Ui_Thresholds_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your heart rate and power baselines`)
};

const de_ui_thresholds_subtitle = /** @type {(inputs: Ui_Thresholds_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Herzfrequenz- und Leistungs-Grundwerte`)
};

/**
* | output |
* | --- |
* | "Your heart rate and power baselines" |
*
* @param {Ui_Thresholds_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_subtitle = /** @type {((inputs?: Ui_Thresholds_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_subtitle(inputs)
	return de_ui_thresholds_subtitle(inputs)
});